/* eslint-disable import/prefer-default-export */
export const PHONE_REGEX = /^(\+1|\d{1,2})?\s*[(]?\d{3}[)]?\s*\d{3}-\d{4}$/;

export const SSN_REGEX = [
    // Regexp explanation: https://ihateregex.io/expr/ssn
    /^(?!0{3})(?!6{3})[0-8]\d{2}-(?!0{2})\d{2}-(?!0{4})\d{4}$/gm,
    // This regex matches the following patterns:

    // A valid SSN, with or without dashes.
    // Any invalid SSN that starts with 000, 666, 900-999, 123-45-6789, 999-99-9999, 078051120, or 219099999.
    // The regex has the following parts:

    // ^(?!000|666|900-999|123-45-6789|999-99-9999|078051120|219099999) : This is a negative lookahead assertion that matches if the string does not start with any of the known invalid SSNs.
    // \d{3} : This matches three digits.
    // - : This matches a hyphen.
    // \d{2} : This matches two digits.
    // - : This matches a hyphen.
    // \d{4} : This matches four digits.
    /^(?!000|666|900-999|123-45-6789|999-99-9999|078051120|219099999)^\d{3}-\d{2}-\d{4}$/,
];

export const EIN_REGEX = /^\d{2}-\d{7}$/;

// Banking field validation patterns
// Letters, spaces, hyphens, apostrophes, periods (e.g. "O'Brien", "St. Louis")
export const NAME_REGEX = /^[a-zA-Z\s\-'.]+$/;
// Bank names can also include numbers, & and commas (e.g. "1st National Bank", "Chase, N.A.", "Goldman Sachs & Co., Inc.")
export const BANK_NAME_REGEX = /^[a-zA-Z0-9\s\-'.&,]+$/;
// Addresses include numbers, #, / (e.g. "123 Main St.", "Apt #4B", "1/2 Oak Ave")
export const ADDRESS_REGEX = /^[a-zA-Z0-9\s\-'.,#/]+$/;
// City names - letters, spaces, hyphens, apostrophes, periods (e.g. "St. Paul", "Winston-Salem")
export const CITY_REGEX = /^[a-zA-Z\s\-'.]+$/;
// General text - alphanumeric with common punctuation (e.g. "FBO Smith & Co.", "Invoice #123", "Urgent!")
export const TEXT_REGEX = /^[a-zA-Z0-9\s\-'.,;:/#()&!]+$/;
// Wire remittance field - must match Fortis `remittanceInformation` pattern: letters, digits, hyphens, spaces, periods, commas
export const WIRE_REMITTANCE_REGEX = /^[a-zA-Z0-9- .,]*$/;
// Wire beneficiary name - the character set Fortis confirmed for this field:
// letters, digits, a space, and / - ? : ( ) . , ' + (e.g. "4Gold LLC", "Acme Inc.")
// Fortis gave it as \A[a-zA-Z0-9\/\-?:().,\'+ ]+\z; JS has no \A/\z, so ^ and $
// (never with the multiline flag) are the equivalent anchors. "&" is not accepted.
export const WIRE_BENEFICIARY_NAME_REGEX = /^[a-zA-Z0-9/\-?:().,'+ ]+$/;
const SEPARATOR = String.raw`[\s./_-]*`;
const RURAL_ROUTE_BOX = String.raw`\b(?:r[\s.]*r|rural${SEPARATOR}route|h[\s.]*c|highway${SEPARATOR}contract)[\s.#]*\d*[\s,]*(?:box|bin)\b`;
const BARE_BOX_WORD = `(?:(?:mail${SEPARATOR})?(?:box|bin)|drawer|(?:firm${SEPARATOR})?caller(?:${SEPARATOR}box)?)`;
const BOX_NUMBER = String.raw`[\s.#:-]*(?:(?:no|num(?:ber)?)\.?[\s#]*)?\d`;
export const PO_BOX_REGEX = new RegExp([
    String.raw`\b(?:${[
        `p(?:ost(?:al)?)?${SEPARATOR}o(?:ff(?:ice)?)?${SEPARATOR}b(?:o?x|in)?`,
        `post(?:al)?${SEPARATOR}(?:office${SEPARATOR})?(?:box|bin)`,
        String.raw`p[\s.]*m[\s.]*b`,
        `private${SEPARATOR}mail${SEPARATOR}box`,
        `lock${SEPARATOR}box`,
    ].join('|')})(?![a-z])`,
    String.raw`^(?![\s\S]*${RURAL_ROUTE_BOX})[\s\S]*?\b${BARE_BOX_WORD}${BOX_NUMBER}(?![a-z])`,
].join('|'), 'i');
// Digits only
export const DIGITS_ONLY_REGEX = /^\d+$/;
